import { useTranslation } from 'react-i18next'
import { Box, Typography, Paper, Stack, Chip, LinearProgress } from '@mui/material'
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material'
import { SyncProgress } from '@/core/offline/types/database.types'

export function DetailedSyncProgress({ syncProgress }: { syncProgress: SyncProgress }) {
  const { t } = useTranslation()

  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <CloudUploadIcon
            color={syncProgress.stage === 'uploading' ? 'primary' : 'action'}
            sx={{
              animation: syncProgress.stage === 'uploading' ? 'pulse 2s infinite' : 'none',
              '@keyframes pulse': {
                '0%': { opacity: 1 },
                '50%': { opacity: 0.5 },
                '100%': { opacity: 1 },
              },
            }}
          />
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2" color="primary">
              {syncProgress.message || t('offline.sync.dashboard.syncing')}
            </Typography>
            {syncProgress.currentItem && (
              <Typography variant="body2" color="text.secondary">
                {syncProgress.currentItem.description} - {syncProgress.currentItem.entityType}
              </Typography>
            )}
            {syncProgress.currentStep && (
              <Typography variant="caption" color="text.secondary">
                {syncProgress.currentStep}
              </Typography>
            )}
          </Box>
          <Chip label={`${syncProgress.progress}%`} color={syncProgress.stage === 'uploading' ? 'primary' : 'default'} size="small" />
        </Stack>
        <LinearProgress
          variant="determinate"
          value={syncProgress.progress}
          sx={{
            height: 6,
            borderRadius: 3,
            backgroundColor: 'action.hover',
            '& .MuiLinearProgress-bar': {
              borderRadius: 3,
              backgroundColor: syncProgress.stage === 'uploading' ? 'primary.main' : 'success.main',
            },
          }}
        />
      </Stack>
    </Paper>
  )
}
